import { Colors } from "@/enums/Colors";
import { LazoPaths } from "@/enums/LazoPaths";
import { Box, styled, Typography, typographyClasses } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCircleSVG from "../../../assets/images/data-room/check-circle.svg";

function DataRoomUploadCompleteMessage() {
  const { t } = useTranslation("virtualDataRooms");
  return (
    <>
      <RootContainer>
        <img src={CheckCircleSVG.src} />
        <MessageContainer>
          <Typography fontSize="1.25rem" fontWeight="500" lineHeight="24px">
            {t("fileUpload.completeMessage.title")}
          </Typography>
          <Typography color={Colors.LIGHT_GRAY_8A8E93} fontSize="0.875rem" fontWeight="400" lineHeight="24px">
            {t("fileUpload.completeMessage.description")}
            <a className="link" href={LazoPaths.ONE_DATA_ROOM_FILES}>
              {t("fileUpload.completeMessage.linkText")}
            </a>
          </Typography>
        </MessageContainer>
      </RootContainer>
    </>
  );
}

const RootContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
}));

const MessageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "0.25rem",
  [`& .${typographyClasses.root}`]: {
    "& .link": {
      fontWeight: "500",
    },
  },
}));

export default DataRoomUploadCompleteMessage;
